import { useRouter } from "next/router";
import React, { PropsWithChildren } from "react";
import { routesDefinitions } from "lib/actions/routeDefinitions";
import ProjectProviders from "./ProjectProviders";

/** Route paths to greater-than-route providers. Resulting providers are the
 *  first regular expression that matches the url pathname (initial '/' followed
 *  by the path of the URL not including the query string or fragment.)
 *
 *  The primary purpose is to persist state providers between a collection of routes,
 *  whilst dropping those states when exiting the bounds of those routes.
 *
 *  This can easily be removed if - with time - it proves overly complicated to manage.
 */
const routeProviders = [
  { path: routesDefinitions.project.regex, providers: "project" },
  { path: routesDefinitions.projectSettings.regex, providers: "project" },
  { path: routesDefinitions.layers.regex, providers: "project" },
  { path: routesDefinitions.views.regex, providers: "project" },
  { path: routesDefinitions.assetPages.regex, providers: "project" },
  { path: routesDefinitions.modelElement.regex, providers: "project" },
  { path: routesDefinitions.members.regex, providers: "project" },
  { path: routesDefinitions.issues.regex, providers: "project" },
  { path: routesDefinitions.search.regex, providers: "project" },
  { path: /^\/.*/, providers: "none" }, //otherwise
] as const;

const ProviderRouter = (p: PropsWithChildren<{}>) => {
  const router = useRouter();
  const providers = routeProviders.find((r) =>
    r.path.test(router.pathname),
  )?.providers;

  switch (providers) {
    case "project":
      return <ProjectProviders>{p.children}</ProjectProviders>;
    case "none":
    default:
      return <>{p.children}</>;
  }
};

export default ProviderRouter;
